<!-- Mobile: Use Drawer overlay (has built-in animations) with icons + text -->
@if (isMobile()) {
  <p-drawer
    [visible]="visible()"
    [modal]="true"
    [dismissible]="true"
    position="left"
    class="w-full! md:w-75!"
    (onHide)="onHide()"
  >
    <ng-template pTemplate="header">
      <img src="/images/galaxy-letters-nav-bar.png" alt="Galaxy" class="h-6 w-auto" />
    </ng-template>

    <ng-template pTemplate="content">
      <nav class="flex flex-col py-2">
        @for (item of navItems(); track item.label) {
          <a
            [routerLink]="item.routerLink"
            [class.active]="isActive(item)"
            class="sidenav-mobile-item"
            (click)="item.command?.({})"
          >
            @if (item.iconImage) {
              <img [src]="item.iconImage" [alt]="item.label" class="w-[22.4px] h-[22.4px] shrink-0 object-contain" />
            } @else if (item.svgIcon) {
              <svg
                [attr.viewBox]="item.svgIcon.viewBox"
                [class]="(item.svgIcon.sizeClass ?? 'w-[22.4px] h-[22.4px]') + ' shrink-0'"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                @for (path of item.svgIcon.paths; track path) {
                  <path [attr.d]="path" />
                }
                @for (badge of item.svgIcon.overlay; track badge.d) {
                  <path [attr.d]="badge.d" [attr.fill]="badge.fill" [attr.transform]="badge.transform" />
                }
              </svg>
            } @else {
              <i [class]="iconClasses(item)"></i>
            }
            <span class="text-base">{{ item.label }}</span>
          </a>
          @if (item.dividerAfter) {
            <hr class="sidenav-divider" />
          }
        }
      </nav>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="p-4 text-center border-t border-white/10">
        <div class="text-sm text-(--text-color-secondary)">
          <span>v{{ appVersion }}</span>
        </div>
        <div class="flex justify-center">
          <span class="inline-block px-2 py-0.5 border border-(--text-color-secondary) rounded text-sm font-bold uppercase text-(--text-color-secondary)">{{ environmentName }}</span>
        </div>
      </div>
    </ng-template>
  </p-drawer>
}

<!-- Desktop: Icon-only sidebar with tooltips -->
@if (!isMobile()) {
  <aside
    class="fixed top-14 left-0 flex flex-col h-[calc(100vh-3.5rem)] w-20 z-10 transition-all duration-300 ease-in-out bg-(--p-galaxy-surface-header) border-r border-white/10"
    [class.-translate-x-full]="!visible()"
  >
    <nav class="flex flex-col flex-1 overflow-y-auto py-4 bg-(--p-galaxy-surface-header)">
      @for (item of navItems(); track item.label) {
        <a
          [routerLink]="item.routerLink"
          [class.active]="isActive(item)"
          class="sidenav-icon-item"
          [pTooltip]="item.label"
          tooltipPosition="right"
          (click)="item.command?.({})"
        >
          @if (item.iconImage) {
            <img [src]="item.iconImage" [alt]="item.label" class="w-[22.4px] h-[22.4px] object-contain" />
          } @else if (item.svgIcon) {
            <svg
              [attr.viewBox]="item.svgIcon.viewBox"
              [class]="item.svgIcon.sizeClass ?? 'w-[22.4px] h-[22.4px]'"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              @for (path of item.svgIcon.paths; track path) {
                <path [attr.d]="path" />
              }
              @for (badge of item.svgIcon.overlay; track badge.d) {
                <path [attr.d]="badge.d" [attr.fill]="badge.fill" />
              }
            </svg>
          } @else {
            <i [class]="iconClasses(item)"></i>
          }
        </a>
        @if (item.dividerAfter) {
          <hr class="sidenav-divider" />
        }
      }
    </nav>

    <div class="py-4 text-center border-t border-white/10 bg-(--p-galaxy-surface-header)">
      <div class="text-xs text-(--text-color-secondary)">
        <span>v{{ appVersion }}</span>
      </div>
      <div class="flex justify-center">
        <span class="inline-block px-1.5 py-0.5 border border-(--text-color-secondary) rounded text-sm font-bold uppercase text-(--text-color-secondary)">{{ environmentName }}</span>
      </div>
    </div>
  </aside>
}
